// import mind.yushu.com.mindmap.viewmodel.mindelementdata.LineMindTypeNode;
// import mind.yushu.com.mindmap.viewmodel.mindelementdata.MindElementData;

import LineMindTypeNode from "../../../viewmodel/mindelementdata/LineMindTypeNode"
import MindElementData from "../../../viewmodel/mindelementdata/MindElementData"
import BaseLayout from '../../../viewmodel/core/layout/BaseLayout'
import HashMap from "../../../viewmodel/core/base/HashMap";
import Config from "./Config";
import IdGenerator from "../../../viewmodel/core/base/IdGenerator";
import UiUtil from "../../../utils/UiUtil";
import Colors from "../../../utils/Colors";
import CGRect from "../../../viewmodel/core/base/basedata/Rect";
/**
 * Created by tony on 2019/12/27
 */

class NodesRectCalculation {
    constructor(explainMinds = new HashMap(), encircleElementDataDict = new HashMap(), 
            isCalculeTargetExplain = true, isCalculeTargetEncircle = true) {
        this.explainMindElementDataDict = explainMinds;
        this.encircleMindElementDataDict = encircleElementDataDict;
        this.isCalculeTargetExplain = isCalculeTargetExplain;
        this.isCalculeTargetEncircle = isCalculeTargetEncircle;
        this.targetData = new MindElementData()
        this.dataList = new Array();
    }

    getNodes(node) {
        this.dataList = [];
        this.setNodeDataList(node);
        return this.dataList;
    }

    getNodesForHeight(node) {
        this.dataList = [];
        this.setNodeDataListForHeight(node, new LineMindTypeNode());
        return this.dataList;
    }

    calcule(node) {
        if (node == null) {
            return new CGRect(0, 0, 0, 0);
        }
        this.dataList = [];
        this.targetData = node.value
        this.setNodeDataList(node);
        this.setEncircleData();
        this.setNodeExplain();
        return this.calculeDatas(this.dataList);
    }

    setEncircleData() {
        let encircleMindElementDataDict = this.encircleMindElementDataDict.keys();
        let encircleMindElementDataDictCount = encircleMindElementDataDict.length;
        let addEncircleDataList = [];
        for (let index = 0; index < encircleMindElementDataDictCount; index++) {
            let mind = this.encircleMindElementDataDict.get(encircleMindElementDataDict[index]);
            if (mind.lineContent == null) {
                continue;
            }
            var isOk = false;
            for (let j = 0; j < this.dataList.length; j++) {
                if (mind.parentNodeId == this.dataList[j].id) {                    
                    isOk = true;
                    break;
                }
            }
            if (isOk) {
                addEncircleDataList.push(mind)
                continue
            }    
            let targetIds = new Array();
            if (mind.lineContent != null) {
                targetIds = mind.lineContent.targetIds;
            }
            if (targetIds.isEmpty()) {
                targetIds.push(mind.parentNodeId);
            }
            let targetIdsCount = targetIds.length;
            for (let i = 0; i < targetIdsCount; i++) {
                let id = targetIds[i];
                for (let j = 0; j < this.dataList.length; j++) {
                    if (id == this.dataList[j].id) {                    
                        isOk = true;
                        break;
                    }
                }
                if (isOk) {
                    break
                }
            }
            if (isOk) {
                addEncircleDataList.push(mind)
                continue
            }
        }

        for (let j = 0; j < addEncircleDataList.length; j++) {
            if (!this.isCalculeTargetEncircle && this.targetData.id == addEncircleDataList[j].id) {
                continue;
            }
            this.dataList.push(addEncircleDataList[j])
        }

    }

    setNodeExplain() {
        let addDataList = [];
        let explainMindElementDataDictKeys = this.explainMindElementDataDict.keys();
        let explainMindElementDataDictKeysCount = explainMindElementDataDictKeys.length;
        for (let index = 0; index < explainMindElementDataDictKeysCount; index++) {
            let key = explainMindElementDataDictKeys[index];
            let item = this.explainMindElementDataDict.get(key)
            var isOk = false;
            for (let j = 0; j < this.dataList.length; j++) {
                if (item.parentNodeId == this.dataList[j].id) {                    
                    isOk = true;
                    break;
                }
            }
            if (isOk) {
                addDataList.push(item)
                continue
            }
        }
        for (let j = 0; j < addDataList.length; j++) {
            if (!this.isCalculeTargetExplain && this.targetData.id == addDataList[j].id) {
                continue;
            }
            this.dataList.push(addDataList[j])
        }
    }

    setNodeDataListForHeight(node, parentNode) {
        if (node.value.isHidden) {
            return;
        }
        
        if (parentNode == null || parentNode.isEmpty() ||
            parentNode.children.length == 0) {
            this.dataList.push(node.value);
        } else {
            let nodeIndex = -1;
            for (let index = 0; index < parentNode.children.length; index++) {
                const child = parentNode.children[index];
                if (child.value.id == node.value.id) {
                    nodeIndex = index;
                    break;
                }
            }
            if (parentNode.children.length > 1 && nodeIndex > 0) {
                this.dataList.push(node.value);
            }
        }      
        node.children.forEach(child => {
            this.setNodeDataListForHeight(child, node);
        });
    }

    setNodeDataList(node) {
        if (node.value.isHidden) {
            return;
        }
        this.dataList.push(node.value);
        node.children.forEach(child => {
            this.setNodeDataList(child);
        });
    }

    calculeNodes(nodes) {

        var datas = new Array();
        nodes.forEach(node => {
            datas.push(node.value);
        });

        return this.calculeDatas(datas);
    }

    calculeDatas(datas) {
        if (datas.length == 0) {
            return new CGRect(0, 0, 0, 0);
        }

        var left = 1000000;
        var top = 1000000;
        var right = -1000000;
        var bottom = -1000000;
        datas.forEach(mind => {
            if (!mind.isHidden) {
                left = Math.min(left, mind.x);
                top =  Math.min(top, mind.y);
                right = Math.max(right, mind.x + mind.width)
                bottom = bottom < mind.y + new BaseLayout().getNodeHeight(mind) ? mind.y + new BaseLayout().getNodeHeight(mind) : bottom;
            }
            
        });
        return new CGRect(left, top, right -left , bottom - top);
    }
}

export default NodesRectCalculation
